import React from 'react'
import { NavCheckpointProps } from './props'

import * as S from './styles'
import { theme } from '../../../styles/theme'
import { funcEmpty } from '../../../helpers/helper-function'

const NavCheckpoint = ({
  pageNames,
  currentIndex = 0,
  onChangeStep,
}: NavCheckpointProps) => {
  const getColorBy = (aIndex: number) => {
    if (aIndex === currentIndex) {
      return {
        border: `2px solid ${theme.colors.orange}`,
        background: theme.colors.mainBg,
      }
    }

    if (aIndex < currentIndex) {
      return {
        border: `2px solid ${theme.colors.orange}`,
        background: theme.colors.orange,
      }
    }

    return {
      border: `2px solid ${theme.colors.darkGray}`,
      background: theme.colors.mainBg,
    }
  }

  return (
    <S.Container>
      {pageNames.map((page: string, index: number) => (
        <>
          {index > 0 && (
          <S.Separator style={{
            background: index <= currentIndex
              ? theme.colors.orange
              : theme.colors.darkGray,
          }}
          />
          )}
          <S.Step>
            <S.Check
              style={getColorBy(index)}
              onClick={(onChangeStep && (index <= currentIndex))
                ? () => onChangeStep(index)
                : funcEmpty}
            />
            <p>{page}</p>
          </S.Step>
        </>
      ))}
    </S.Container>
  )
}

export default NavCheckpoint
